import { render, staticRenderFns } from "./PrestationReferencesList.vue?vue&type=template&id=58ce2a25"
import script from "./PrestationReferencesList.vue?vue&type=script&lang=js"
export * from "./PrestationReferencesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports